import React from "react";
import { Link, useLocation } from "react-router-dom";
import styles from "./KioskMenuItem.module.css";
import placeholder600x440 from "assets/placeholder/600x440.png";

const KioskMenuItem = ({thumb, type, click}) => {
  const location = useLocation();
  const pathname = location.pathname.replace(/\/+$/, "");
  return (
    <div className={styles.KioskMenuItem} onClick={click}>
      <Link to={pathname + "/" + type}>
        <img src={thumb ? thumb  : placeholder600x440 } alt="menu-item" className="img-fluid" />
      </Link>
    </div>
  );
};

export default KioskMenuItem;
